/**限时折扣初始化数据处理 */
export function fullDiscountInitData(_this) {
  /**限时折扣 */
  if (_this.fullDiscountRule.discountenable == 1) {
    _this.fullDiscountRuleList = []
    for (let key in _this.fullDiscountRule.ruleObj) {
      if (_this.fullDiscountRule.ruleObj.hasOwnProperty(key)) {
        _this.fullDiscountRule.ruleObj[key].rulelist.forEach((item) => (item.ruleId = key))
        _this.fullDiscountRuleList = [
          ..._this.fullDiscountRuleList,
          ..._this.fullDiscountRule.ruleObj[key].rulelist
        ]
      }
    }
    _this.fullDiscountRuleTitle =
      _this.fullDiscountRule.ruleObj && Object.keys(_this.fullDiscountRule.ruleObj).length > 1
        ? '限时折扣'
        : _this.fullDiscountRule.ruleObj[Object.keys(_this.fullDiscountRule.ruleObj)[0]].actlabel
  }
}
/**限时折扣 */
export function fullDiscountRuleHandle(_this) {
  _this.fullDiscountChooseNums = {}
  _this.fullDiscountmoney = 0
  _this.isChooseProduct.forEach((item) => {
    if (item.isFullDiscount == 1 && item.fullDiscountRuleId) {
      let ruleId = item.fullDiscountRuleId
      if (_this.fullDiscountChooseNums[ruleId]) {
        _this.fullDiscountChooseNums[ruleId] += parseInt(item.num)
      } else {
        _this.fullDiscountChooseNums[ruleId] = parseInt(item.num)
      }
    }
  })
  _this.fullDiscountRuleList.forEach((item) => {
    if (_this.fullDiscountChooseNums[item.ruleId]) {
      item.marginNum = _this.fullDiscountChooseNums[item.ruleId] - parseFloat(item.num || 0)
    } else {
      delete item.marginNum
    }
  })
  if (_this.fullDiscountRuleList && _this.fullDiscountRuleList.length) {
    let rulelist = _this.fullDiscountRuleList
    _this.list.map((item) => {
      if (item.isFullDiscount == 1 && item.fullDiscountRuleId) {
        let ruleId = +item.fullDiscountRuleId
        let chooselen = _this.fullDiscountChooseNums[ruleId]
          ? _this.fullDiscountChooseNums[ruleId]
          : 0
        for (let i = 0; i < rulelist.length; i++) {
          if (
            rulelist[i].ruleId == ruleId &&
            (((item.ischoose == true || item.ischoose == 1) &&
              chooselen >= parseInt(rulelist[i].num)) ||
              item.num >= parseInt(rulelist[i].num))
          ) {
            item.fullDiscountPrice =
              item.temp_sales_price - parseFloat(item.price) * parseFloat(rulelist[i].discount)
            item.sales_price = parseFloat(item.price) * parseFloat(rulelist[i].discount)
            if (
              (item.ischoose == true || item.ischoose == 1) &&
              chooselen >= parseInt(rulelist[i].num) &&
              (item.isBirthdayDiscount != 1 ||
                (item.isBirthdayDiscount == 1 &&
                  rulelist[i].discount < _this.birthdayDiscountRule.discount))
            ) {
              _this.fullDiscountmoney += item.fullDiscountPrice * item.num
            }
            break
          } else {
            item.sales_price = item.temp_sales_price ? item.temp_sales_price : item.sales_price
            item.fullDiscountPrice = 0
          }
        }
      } else {
        item.sales_price = item.temp_sales_price ? item.temp_sales_price : item.sales_price
        item.fullDiscountPrice = 0
      }
    })
  }
}

/**生日折扣 */
export function birthdayDiscountRuleHandle(_this) {
  if (_this.birthdayDiscountRule.discountenable == 1) {
    _this.birthdayDiscountmoney = 0
    _this.list.map((item) => {
      if (item.isBirthdayDiscount == 1) {
        item.birthdayDiscountPrice =
          item.temp_sales_price -
          parseFloat(item.price) * parseFloat(_this.birthdayDiscountRule.discount)
        if (item.birthdayDiscountPrice >= item.fullDiscountPrice || !item.fullDiscountPrice) {
          item.sales_price =
            parseFloat(item.price) * parseFloat(_this.birthdayDiscountRule.discount)
          if (item.ischoose == true || item.ischoose == 1) {
            _this.birthdayDiscountmoney += item.birthdayDiscountPrice * item.num
          }
        } else {
          if (!item.fullDiscountPrice)
            item.sales_price = item.temp_sales_price ? item.temp_sales_price : item.sales_price
          item.birthdayDiscountPrice = 0
        }
      } else {
        if (!item.fullDiscountPrice)
          item.sales_price = item.temp_sales_price ? item.temp_sales_price : item.sales_price
        item.birthdayDiscountPrice = 0
      }
    })
  }
}
/**折上折,限时折扣,满减,满赠 */
export function discountHandle(_this, { discountlist, discount_rule }) {
  _this.fullDiscountEnter = -1
  if (/**折上折 */ _this.discountrule && _this.discountrule.discountenable == 1) {
    discount_rule = {..._this.discountrule, chooseNum: _this.discountGoodsnum}
    discountFn({})
  } else if (/**限时折扣 */ _this.fullDiscountRule && _this.fullDiscountRule.discountenable == 1) {
    let rulelist = []
    // 过滤掉没有 marginNum 的数据
    let filteredList = _this.fullDiscountRuleList.filter((item) => 'marginNum' in item)
    // 排序
    if (filteredList.length > 0) {
      // 对过滤后的数据进行排序
      rulelist = filteredList
        .sort((a, b) => {
          // 先根据 marginNum 排序
          if (a.marginNum < 0 && b.marginNum >= 0) {
            return -1
          } else if (a.marginNum >= 0 && b.marginNum < 0) {
            return 1
          } else if (a.marginNum >= 0 && b.marginNum >= 0) {
            // marginNum 都大于等于 0 时，从小到大排序
            return a.marginNum - b.marginNum
          } else {
            // marginNum 都小于 0 时，从大到小排序
            return b.marginNum - a.marginNum
          }
        })
        .sort((a, b) => {
          // 当 marginNum 相同时，按照 discount 从大到小排序
          if (a.marginNum === b.marginNum) {
            return parseFloat(b.discount) - parseFloat(a.discount)
          }
          return 0
        })
    }

    let discountlistTemp =
      rulelist.length > 0
        ? _this.fullDiscountRule.ruleObj[rulelist[0].ruleId].rulelist || []
        : _this.fullDiscountRule.ruleObj[Object.keys(_this.fullDiscountRule.ruleObj)[0]].rulelist ||
          []
    let chooseNum = rulelist.length > 0 ? _this.fullDiscountChooseNums[rulelist[0].ruleId] : 0
    discount_rule = {
      discountenable: _this.fullDiscountRule.discountenable,
      chooseNum,
      discountlist: discountlistTemp
    }
    discount_rule.discountlist.forEach((item) => {
      item.itemnum = item.num
    })
    let type =
      _this.fullDiscountRule.ruleObj && Object.keys(_this.fullDiscountRule.ruleObj).length > 1
        ? 'fullDiscount'
        : undefined
    _this.fullDiscountEnter = 0
    discountFn({ type })
    if (_this.fullDiscountRule.switch != 1) {
      _this.FlodMsg = ''
    }
  }
  function discountFn({ type }) {
    discountlist = discount_rule.discountlist || []
    let chooseNum = discount_rule.chooseNum != undefined ? discount_rule.chooseNum : 0
    if (parseInt(chooseNum) == 0) {
      var discount = discountlist[0].discount
      discount = Math.round(discount * 100 * 100) / 100 /**处理精度 */
      var txt = discount % 10 == 0 ? discount / 10 : discount
      if (type == 'fullDiscount') {
        _this.FlodMsg = '惊喜！选购活动商品可享受更低折扣购买'
      } else {
        _this.FlodMsg = '惊喜！选购活动商品最高可享受' + txt + '折'
      }
      if (_this.fullDiscountEnter == 0) _this.fullDiscountEnter = 1
      _this.currentdiscount = 1
    } else if (parseInt(chooseNum) >= parseInt(discountlist[0].itemnum)) {
      let discount = discountlist[0].discount
      discount = Math.round(discount * 100 * 100) / 100 /**处理精度 */
      let txt = discount % 10 == 0 ? discount / 10 : discount
      if (_this.fullgiftrule.actstatus && parseInt(_this.fullgiftrule.actstatus) == 1) {
        _this.FlodMsg = ''
      } else {
        if (type == 'fullDiscount') {
          _this.FlodMsg = '惊喜！已享受限时折扣'
        } else {
          _this.FlodMsg = '惊喜！已选' + chooseNum + '件享' + txt + '折'
        }
      }
      _this.currentdiscount = discount / 100
    } else if (parseInt(chooseNum) < parseInt(discountlist[discountlist.length - 1].itemnum)) {
      let discount1 = discountlist[discountlist.length - 1].discount
      discount1 = Math.round(discount1 * 100 * 100) / 100 /**处理精度 */
      let txt = discount1 % 10 == 0 ? discount1 / 10 : discount1
      if (type == 'fullDiscount') {
        _this.FlodMsg =
          '惊喜！已选' +
          chooseNum +
          '件，再加' +
          (parseInt(discountlist[discountlist.length - 1].itemnum) - chooseNum) +
          '件即可享受更低折扣购买'
      } else {
        _this.FlodMsg =
          '惊喜！已选' +
          chooseNum +
          '件，再加' +
          (parseInt(discountlist[discountlist.length - 1].itemnum) - chooseNum) +
          '件即可享受' +
          txt +
          '折。'
      }
      if (_this.fullDiscountEnter == 0) _this.fullDiscountEnter = 1
      _this.currentdiscount = 1
    } else {
      try {
        discountlist.forEach(function (item, index) {
          if (parseInt(chooseNum) >= parseInt(item.itemnum)) {
            let discount1 = item.discount
            discount1 = Math.round(discount1 * 100 * 100) / 100 /**处理精度 */
            let discount2 = discountlist[index - 1].discount
            discount2 = Math.round(discount2 * 100 * 100) / 100 /**处理精度 */
            let txt = discount1 % 10 == 0 ? discount1 / 10 : discount1 /**已选n件享受的折扣 */
            let txt1 = discount2 % 10 == 0 ? discount2 / 10 : discount2 /**再加n件享受的折扣 */
            if (type == 'fullDiscount') {
              _this.FlodMsg =
                '惊喜！已选' +
                chooseNum +
                '件，再加' +
                (parseInt(discountlist[index - 1].itemnum) - chooseNum) +
                '件即可享受更低折扣购买'
            } else {
              _this.FlodMsg =
                '惊喜！已选' +
                chooseNum +
                '件，再加' +
                (parseInt(discountlist[index - 1].itemnum) - chooseNum) +
                '件即可享受' +
                txt1 +
                '折。'
            }
            if (_this.fullDiscountEnter == 0) _this.fullDiscountEnter = 1
            _this.currentdiscount = discount1 / 100
            throw new Error()
          }
        })
      } catch (e) {}
    }
  }

  /**满减 */
  if (_this.fullMinusRules.actStatus == 1) {
    if (_this.fullMinusRules.isSuperpose == 1 && _this.fullMinus_totalmoney > 0) {
      let variable = Math.floor(
        _this.fullMinus_totalmoney / parseFloat(_this.fullMinusRules.fullMoney)
      )
      variable = variable + 1
      let m = parseFloat(
        parseFloat(_this.fullMinusRules.fullMoney) * variable - _this.fullMinus_totalmoney
      ).toFixed(2)
      let fullminusmoney_temp =
        _this.fullMinus_totalmoney -
        parseFloat(_this.fullMinusRules.fullMoney) * (variable > 1 ? variable - 1 : 1)
      if (fullminusmoney_temp > 0) {
        _this.fullMinusMsg = `已减${(
          parseFloat(_this.fullMinusRules.minusMoney) * (variable > 1 ? variable - 1 : 1)
        ).toFixed(2)}元，<span>还差${parseFloat(m).toFixed(2)}元</span>满${
          parseFloat(_this.fullMinusRules.fullMoney) * variable
        }减${parseFloat(_this.fullMinusRules.minusMoney) * variable}`
      } else {
        _this.fullMinusMsg = `已选${parseFloat(_this.fullMinus_totalmoney).toFixed(
          2
        )}元，<span>还差${parseFloat(m).toFixed(2)}元</span>满${
          parseFloat(_this.fullMinusRules.fullMoney) * variable
        }减${parseFloat(_this.fullMinusRules.minusMoney) * variable}`
      }
      _this.fullminusmoney = parseFloat(_this.fullMinusRules.minusMoney) * (variable - 1)
    } else if (_this.fullMinus_totalmoney > 0) {
      if (_this.fullMinus_totalmoney < _this.fullMinusRules.fullMoney) {
        let m = parseFloat(
          parseFloat(_this.fullMinusRules.fullMoney) - _this.fullMinus_totalmoney
        ).toFixed(2)
        _this.fullMinusMsg = `已选${parseFloat(_this.fullMinus_totalmoney).toFixed(
          2
        )}元，<span>还差${parseFloat(m).toFixed(2)}元</span>满${parseFloat(
          _this.fullMinusRules.fullMoney
        )}减${parseFloat(_this.fullMinusRules.minusMoney)}`
        _this.fullminusmoney = 0
      } else {
        _this.fullMinusMsg = `已选${parseFloat(_this.fullMinus_totalmoney).toFixed(
          2
        )}元，满${parseFloat(_this.fullMinusRules.fullMoney)}减${parseFloat(
          _this.fullMinusRules.minusMoney
        )}<span>可减${parseFloat(_this.fullMinusRules.minusMoney).toFixed(2)}元</span>`
        _this.fullminusmoney = parseFloat(_this.fullMinusRules.minusMoney)
      }
    } else {
      _this.fullMinusMsg = `活动进行中，${_this.fullMinusRules.actLabel}`
      _this.fullminusmoney = 0
    }
    _this.totalmoney = _this.totalmoney - _this.fullminusmoney
  }

  /**满赠 */
  if (_this.fullgiftrule && parseInt(_this.fullgiftrule.actstatus) == 1 && !_this.FlodMsg) {
    if (_this.fullgiftrule.rulelist && _this.fullgiftrule.rulelist.length > 0) {
      var rulelist = _this.fullgiftrule.rulelist
      var price = 0
      _this.isChooseProduct.forEach(function (item) {
        let morediscountsmoney = 0, fullminusmoney = 0
        if (item.isfullgift == 1) {
          if (item.ismorediscounts && item.num >= item.morediscountsitemnum) {
            if (item.issuperposition != 0) {
              morediscountsmoney =
                parseFloat(item.morediscountsmoney) * parseInt(item.num / item.morediscountsitemnum)
            } else {
              morediscountsmoney = parseFloat(item.morediscountsmoney)
            }
          }
          if (item.isfullMinus == 1 || (item.fullMonusRules && item.fullMonusRules.isfullMinus == 1)) {
            fullminusmoney = parseFloat(
              Number(item.sales_price) * parseInt(item.num) * (_this.fullminusmoney / _this.fullMinus_totalmoney)
            )
          }
          if (parseInt(item.isdiscount) == 1 && _this.currentdiscount > 0) {
            price +=
              Number(item.sales_price) * parseInt(item.num) * Number(_this.currentdiscount)
          } else {
            price += Number(item.sales_price) * parseInt(item.num)
          }
          price = price - morediscountsmoney - fullminusmoney
        }
      })
      _this.currentfullgiftmoney = parseFloat(price).toFixed(2)
      if (!isNaN(Number(_this.currentfullgiftmoney))) {
        if (
          parseFloat(_this.currentfullgiftmoney) == 0 ||
          parseFloat(_this.currentfullgiftmoney) <
            parseFloat(rulelist[rulelist.length - 1].allmoney)
        ) {
          let m = !isNaN(Number(rulelist[rulelist.length - 1].allmoney))
            ? parseFloat(
                Number(rulelist[rulelist.length - 1].allmoney) - Number(_this.currentfullgiftmoney)
              ).toFixed(2)
            : '0.00'
          let m1 = !isNaN(parseFloat(rulelist[rulelist.length - 1].senditemprice))
            ? parseFloat(rulelist[rulelist.length - 1].senditemprice).toFixed(2)
            : '0.00'
          _this.FullGiftMsg =
            '惊喜！还差<span>' +
            m +
            '</span>元，即送价值<span>' +
            (parseFloat(m1) > 0
              ? m1
              : parseFloat(rulelist[rulelist.length - 1].itemprice).toFixed(2)) +
            '</span>元' +
            rulelist[rulelist.length - 1].senditemname
        } else if (parseFloat(_this.currentfullgiftmoney) >= parseFloat(rulelist[0].allmoney)) {
          let m = !isNaN(parseFloat(rulelist[0].allmoney))
            ? parseFloat(rulelist[0].allmoney).toFixed(2)
            : '0.00'
          let m1 = !isNaN(parseFloat(rulelist[0].senditemprice))
            ? parseFloat(rulelist[0].senditemprice).toFixed(2)
            : '0.00'
          _this.FullGiftMsg =
            '惊喜！已满<span>' +
            m +
            '</span>元，送价值<span>' +
            (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[0].itemprice).toFixed(2)) +
            '</span>元' +
            rulelist[0].senditemname
        } else {
          try {
            rulelist.forEach(function (item, index) {
              if (parseFloat(_this.currentfullgiftmoney) >= parseFloat(item.allmoney)) {
                let m = !isNaN(parseFloat(rulelist[index].allmoney))
                  ? parseFloat(Number(rulelist[index].allmoney)).toFixed(2)
                  : '0.00'
                let m1 = !isNaN(parseFloat(rulelist[index].senditemprice))
                  ? parseFloat(rulelist[index].senditemprice).toFixed(2)
                  : '0.00'
                _this.FullGiftMsg =
                  '惊喜！已满<span>' +
                  m +
                  '</span>元，送价值<span>' +
                  (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[index].itemprice).toFixed(2)) +
                  '</span>元' +
                  rulelist[index].senditemname
                let m2 = !isNaN(parseFloat(rulelist[index - 1].allmoney))
                  ? parseFloat(
                      Number(rulelist[index - 1].allmoney) - Number(_this.currentfullgiftmoney)
                    ).toFixed(2)
                  : '0.00'
                let m3 = !isNaN(parseFloat(rulelist[index - 1].senditemprice))
                  ? parseFloat(rulelist[index - 1].senditemprice).toFixed(2)
                  : '0.00'
                _this.FullGiftMsg +=
                  '，再加<span>' +
                  m2 +
                  '</span>元，奖品升级为价值<span>' +
                  (parseFloat(m3) > 0 ? m3 : parseFloat(rulelist[index - 1].itemprice).toFixed(2)) +
                  '</span>元' +
                  rulelist[index - 1].senditemname
                throw new Error()
              }
            })
          } catch (e) {}
        }
      }
    }
    if (_this.FullGiftMsg != '') _this.FullGiftMsg += '（' + _this.fullgiftrule.actname + '）'
  }
}
/**单品活动描述 */
export function actDescHandle(_this, { obj }) {
  _this.msglist = []
  if (
    _this.discountrule &&
    _this.discountrule.discountenable == 1 &&
    _this.discountrule.discountlist &&
    obj.isdiscount == 1
  ) {
    var msg = []
    _this.discountrule.discountlist.forEach(function (item, index) {
      var txt = (item.discount * 100) % 10 == 0 ? (item.discount * 100) / 10 : item.discount * 100
      msg.push(item.itemnum + '件' + txt + '折')
    })
    var discountruledesc = '满' + msg.join(',')
    _this.msglist.push({
      enable: _this.discountrule.discountenable,
      shortdesc: discountruledesc,
      desc: _this.discountrule.discountdescription,
      name: _this.discountrule.name,
      actlabel: _this.discountrule.actlabel,
      statusmsg: '参与活动商品享受折上折优惠'
    })
  }
  if (
    _this.fullgiftrule &&
    _this.fullgiftrule.actstatus == 1 &&
    _this.fullgiftrule.rulelist &&
    obj.isfullgift == 1
  ) {
    _this.msglist.push({
      enable: _this.fullgiftrule.actstatus,
      shortdesc: _this.fullgiftrule.actdesc,
      desc: _this.fullgiftrule.actdesc,
      name: _this.fullgiftrule.actname,
      actlabel: _this.fullgiftrule.actlabel
    })
  }
  if (_this.halfprice.halfpricestatus == 1 && obj.ishalf == 1) {
    _this.msglist.push({
      enable: _this.halfprice.halfpricestatus,
      shortdesc: _this.halfprice.halfpricedesc,
      desc: _this.halfprice.halfpricedesc,
      name: _this.halfprice.halfactname,
      actlabel: _this.halfprice.halfactlabel
    })
  }
  if (_this.presalerule.actstatus == 1) {
    _this.msglist.push({
      enable: _this.presalerule.actstatus,
      shortdesc: _this.presalerule.actdesc,
      desc: _this.presalerule.actdesc,
      name: _this.presalerule.actname,
      actlabel: '定金翻倍'
    })
  }
  if (_this.fullDiscountRule.discountenable == 1 && obj.fullDiscountRuleId) {
    _this.msglist.push({
      enable: _this.fullDiscountRule.discountenable,
      shortdesc: _this.fullDiscountRule.ruleObj[obj.fullDiscountRuleId].actdesc,
      desc: _this.fullDiscountRule.ruleObj[obj.fullDiscountRuleId].actdesc,
      name: _this.fullDiscountRule.ruleObj[obj.fullDiscountRuleId].actlabel,
      actlabel: _this.fullDiscountRule.ruleObj[obj.fullDiscountRuleId].actlabel
    })
  }
  if (obj.ismorediscounts == 1) {
    _this.msglist.push({
      enable: obj.ismorediscounts,
      shortdesc: obj.morediscountdesc,
      desc: obj.morediscountdesc,
      name: obj.morediscountsname,
      actlabel: obj.morediscountslabel
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/shopcart/js/cart.js